export const filePathsRegex = new RegExp(`^p/.*`, "g");

export const ENV_REGEX = new RegExp(/^<env:[\w-]+>$/);

export const INTEGER_OR_ENV_REGEX = new RegExp(/^(-?\d+|<env:[\w-]+>)$/);
export const DECIMAL_OR_ENV_REGEX = new RegExp(
  /^(-?\d+(\.\d+)?|<env:[\w-]+>)$/
);
export const PHONE_OR_ENV_REGEX = new RegExp(
  /^(((?=.*[0-9])[0-9 +-]{3,})|<env:[\w-]+>)$/
);
export const EMAIL_ENV_OR_SYS_REGEX = new RegExp(
  /^(([a-zA-Z0-9.!#$%&’`*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*)|<env:[\w-]+>|<sys:[\w-]+>)$/
);
export const CURRENCY_OR_ENV_REGEX = new RegExp(/^(\d+(\.\d+)?|<env:[\w-]+>)$/);
export const URL_OR_ENV_REGEX = new RegExp(
  /^((https:\/\/)(?:[\w-]+\.)+[a-z]{2,}(?:\/[\w-./?%&=]*)?|<env:[\w-]+>)$/
);
